module.exports = __webpack_public_path__ + "static/media/slackEmoji6.6516c80a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/slackEmoji6.gif
// module id = 40
// module chunks = 0